import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(
  'pk_test_51SjafnL6sfqeya20UZAntfNI4Sm8M3H7CfIs8awpWmMQajwuwrSwNqn6PqpdlUqzlTtEOQ7qNZarqeTBOsm2HCPr00GGGc8vql',
);
